export default __webpack_public_path__ + "static/media/icons4.c5fe8ae5.svg";